var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3949 15.5514L7.99959 10.1577L2.6043 15.5514C2.01213 16.1468 1.04822 16.1485 0.452764 15.5563C0.452764 15.5563 0.449474 15.553 0.447829 15.5514C-0.147627 14.9592 -0.149272 13.9953 0.442894 13.3998C0.442894 13.3998 0.446184 13.3965 0.447829 13.3949L5.84148 7.99959L0.447829 2.6043C-0.147627 2.01213 -0.149272 1.04822 0.442894 0.452764C0.442894 0.452764 0.446184 0.449474 0.447829 0.447829C1.04 -0.147627 2.00391 -0.149272 2.59937 0.442894C2.59937 0.442894 2.60266 0.446184 2.6043 0.447829L7.99959 5.84148L13.3949 0.447829C13.987 -0.147627 14.951 -0.149272 15.5464 0.442894C15.5464 0.442894 15.5497 0.446184 15.5514 0.447829C16.1468 1.04 16.1485 2.00391 15.5563 2.59937C15.5563 2.59937 15.553 2.60266 15.5514 2.6043L10.1577 7.99959L15.5514 13.3949C16.1468 13.987 16.1485 14.951 15.5563 15.5464C15.5563 15.5464 15.553 15.5497 15.5514 15.5514C14.9592 16.1468 13.9953 16.1485 13.3998 15.5563C13.3998 15.5563 13.3965 15.553 13.3949 15.5514Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.2be144485550059f0cbaf229598acb32.svg";
export { ForwardRef as ReactComponent };